import { ArrowLeft, SearchX } from "lucide-react";
import { useEffect } from "react";

import { Link } from "react-router-dom";
import nookPayLogo from "@src/assets/Favicon.png";
import { getHomeRouteForLoggedInUser } from "@helpers/utils";

const Error = () => {
  useEffect(() => {
    document.title = "404 - Not Found";
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-light px-4 py-12 text-center">
      <Link to="/" className="mb-10 flex items-center gap-2.5">
        <img
          src={nookPayLogo}
          alt="NookPay"
          className="h-9 w-9 rounded-lg object-cover"
        />
        <span className="text-lg font-semibold tracking-tight text-gray-900">
          NookPay
        </span>
      </Link>

      <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-8 shadow-sm sm:p-10">
        <span className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
          <SearchX size={26} />
        </span>

        <div className="text-6xl font-bold tracking-tight text-primary">
          404
        </div>
        <h1 className="mt-2 text-xl font-semibold tracking-tight text-gray-900">
          Page not found
        </h1>
        <p className="mt-3 text-sm leading-6 text-muted">
          Make sure the address is correct and that the page hasn&apos;t moved.
          If you think this is a mistake, contact us.
        </p>

        <Link
          to={getHomeRouteForLoggedInUser("/")}
          className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary px-4 py-2.5 text-sm font-medium text-white shadow transition-colors hover:bg-primary/90"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default Error;
